import React, { useContext, useState } from 'react';
import { Link } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';
import Close from 'assets/icons/closeIcon.svg';
import HamburgerMenu from 'assets/icons/hamburgerMenu.svg';
import SearchIcon from 'assets/icons/searchIcon.svg';
import { SmartLink } from 'components/smart-link';
import { classnames } from 'helpers/utils';
import MaskContext from 'context/maskContext';
import Search from 'components/search';
import { Modal } from 'components/modal';
import { IndexTypeEnum } from 'utils/enums';
import * as styles from './header-mobile.module.scss';
import { CollapsibleItem } from './collapsible-item/collapsible-item';
import { HeaderItemType } from '../types';

const rightIndices = [{ name: IndexTypeEnum.authors }, { name: IndexTypeEnum.articles }];
const leftIndices = [{ name: IndexTypeEnum.tags }];

export const HeaderMobile = (props: HeaderItemType) => {
  const { menuItems, button, popularTopics } = props;
  const { showMask, onShowMaskChange } = useContext(MaskContext);
  const [openModal, setOpenModal] = useState(false);
  const closeModal: () => void = () => {
    setOpenModal(false);
  };

  const onSearchClick = () => {
    onShowMaskChange();
    setOpenModal(!openModal);
  };

  return (
    <div className={classnames(styles.header, styles.genericContainer)}>
      <Link to="/">
        <StaticImage
          placeholder="blurred"
          layout="fixed"
          src="../../../assets/icons/logo.svg"
          alt="teeth talk girl logo"
        />
      </Link>
      <div>
        <div
          role="tab"
          tabIndex={0}
          aria-selected={!showMask}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onShowMaskChange();
            }
          }}
          onClick={onShowMaskChange}
        >
          {showMask
            ? <Close />
            : <HamburgerMenu />}
        </div>
        {showMask && (
        <div className={styles.menuContainer}>
          <div className={styles.genericContainer}>
            {menuItems?.map((item) => (
              <CollapsibleItem key={item.id} menuItem={item} />
            ))}
            <div className={styles.buttonsContainer}>
              <button onClick={onSearchClick}>
                <SearchIcon />
              </button>
              <SmartLink newTab to={button.link} className={styles.subscribeButton}>
                {button.name}
              </SmartLink>
            </div>
          </div>
        </div>
        )}
      </div>
      {openModal && (
        <Modal
          isOpen={openModal}
          onClose={closeModal}
          className={styles.modalContent}
        >
          <Search
            leftIndices={leftIndices}
            rightIndices={rightIndices}
            popularTopics={popularTopics}
          />
        </Modal>
      )}
    </div>
  );
};
